import { getInstance } from "@stadium/services/axios";

import { ORDER_SERVICE_API_URL } from "@constants/env-variables";

export const axiosInstance = getInstance({ baseURL: ORDER_SERVICE_API_URL });
